import { Injectable, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LanguageService } from '../../../core/modules/translate/services/language.service';
import { Languages } from '../../../core/enums/languages';

@Injectable({
  providedIn: 'root',
})
export class CustomToastrService {
  isRtl = false;

  constructor(private toastr: ToastrService, private languageService: LanguageService) {}

  showToast(
    type: 'success' | 'error' | 'info' | 'warning',
    title: string,
    message: string,
    timeout: number = 5000
  ) {
    const options = {
      timeOut: timeout,
      positionClass: this.getPositionClass(),
      closeButton: true,
      progressBar: true,
    };

    (this.toastr[type] as Function).call(this.toastr, message, title, options);
  }

  getPositionClass() {
    this.languageService.currentLanguage.subscribe((lang) => {
      this.isRtl = lang === Languages.AR;
    })
    return this.isRtl ? 'toast-top-left' : 'toast-top-right';
  }
}
